import { useEffect } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { useQuery } from '@tanstack/react-query'

import { QueryKey } from 'lib/queryClient'
import { apiClient } from 'lib/apiClient'
import { getDebugRoute } from 'lib/router'

export const useLegacyRouteRedirect = () => {
  const { id: legacyRouteId } = useParams()

  const navigate = useNavigate()

  const {
    data: supportTextResponse,
    error: supportTextError,
    isLoading: isLoadingSupportText,
  } = useQuery({
    queryKey: [QueryKey.supportTextGenerationStatus, legacyRouteId],
    queryFn: () => apiClient.getSupportTextGeneration(legacyRouteId!),
    enabled: Boolean(legacyRouteId),
  })

  useEffect(() => {
    if (legacyRouteId && supportTextResponse?.correlationId) {
      navigate(getDebugRoute(supportTextResponse?.correlationId))
    }
  }, [navigate, legacyRouteId, supportTextResponse?.correlationId])

  return { supportTextError, isLoadingSupportText }
}
